import { IMG_TYPES, SUPPORTED_LOCALES } from '@repo/config';
import { z } from 'zod';

const imgJobStatusSchema = z.enum([
  'pending',
  'in_progress',
  'rendered',
  'uploading',
  'uploaded',
  'failed',
]);

export type ImgJobStatusType = z.infer<typeof imgJobStatusSchema>;

export const imgJobRowSchema = z.object({
  id: z.number(),
  type: z.enum(IMG_TYPES),
  slug: z.string(),
  locale: z.enum(SUPPORTED_LOCALES),
  status: imgJobStatusSchema,
  attempts: z.number(),
  // biome-ignore lint/style/useNamingConvention: vault SQLite column name
  last_error: z.string().nullable(),
  // biome-ignore lint/style/useNamingConvention: vault SQLite column name
  local_path: z.string().nullable(),
  // biome-ignore lint/style/useNamingConvention: vault SQLite column name
  r2_key: z.string().nullable(),
  // biome-ignore lint/style/useNamingConvention: vault SQLite column name
  created_at: z.number(),
  // biome-ignore lint/style/useNamingConvention: vault SQLite column name
  rendered_at: z.number().nullable(),
  // biome-ignore lint/style/useNamingConvention: vault SQLite column name
  uploaded_at: z.number().nullable(),
  // biome-ignore lint/style/useNamingConvention: vault SQLite column name
  failed_at: z.number().nullable(),
});

export type IImgJobRow = z.infer<typeof imgJobRowSchema>;

const statsByStatusSchema = z.object({
  pending: z.number(),
  // biome-ignore lint/style/useNamingConvention: matches img_job_status enum value
  in_progress: z.number(),
  rendered: z.number(),
  uploading: z.number(),
  uploaded: z.number(),
  failed: z.number(),
});

export type IImgStatsByStatus = z.infer<typeof statsByStatusSchema>;

const statsByTypeSchema = z.object({
  type: z.string(),
  byStatus: statsByStatusSchema,
});

export type IImgStatsByType = z.infer<typeof statsByTypeSchema>;

const statsByLocaleSchema = z.object({
  locale: z.string(),
  byStatus: statsByStatusSchema,
});

export type IImgStatsByLocale = z.infer<typeof statsByLocaleSchema>;

export const imgStatsSchema = z.object({
  total: z.number(),
  byStatus: statsByStatusSchema,
  byType: z.array(statsByTypeSchema),
  byLocale: z.array(statsByLocaleSchema).default([]),
});

export type IImgStats = z.infer<typeof imgStatsSchema>;

export const fetchImgStatusResponseSchema = z.object({
  stats: imgStatsSchema,
  recent: z.array(imgJobRowSchema),
  uploaderPaused: z.boolean(),
});

export type IFetchImgStatusResponse = z.infer<typeof fetchImgStatusResponseSchema>;
